import React from 'react';
import _ from 'lodash';
import {
  Edit,
  FormDataConsumer,
  SimpleForm,
  ReferenceInput,
  SelectInput,
  DisabledInput,
  CardActions,
  ListButton,
  ShowButton,
} from 'react-admin';
import MySelect from './Partials/MySelect';
import { isRequired } from '../../validators';
import { offeringCategory } from '../../helpers/mappings';
import AudienceSegmentSection from './Partials/AudienceSegmentSection';
import SaveOnlyToolbar from '../SaveOnlyToolbar';
import { NEW_SEGMENT } from './constants';

const Title = ({ record }) => (
  <span>Offer Campaign: <strong>{record.id}</strong></span>
);

const Actions = ({ basePath, data, path }) => (
  <CardActions>
    <ShowButton basePath={basePath} record={data} path={path} />
    <ListButton basePath={basePath} />
  </CardActions>
);

export default props => (
  <Edit
    {...props}
    title={<Title />}
    actions={<Actions path={props.location.pathname} />}
    undoable={false}
  >
    <SimpleForm toolbar={<SaveOnlyToolbar />} submitOnEnter={false}>
      <DisabledInput label="Campaign Name" source="metadata.campaignHeader.title" />
      <DisabledInput label="Campaign Subject" source="metadata.campaignHeader.subjectLine" />
      <ReferenceInput
        label="Offer"
        source="offerId"
        reference="offerings"
        validate={isRequired}
      >
        <SelectInput
          optionText={choice => `${choice.name} (${_.values(offeringCategory).find(item => item.value === choice.category).label})`}
        />
      </ReferenceInput>
      <FormDataConsumer>
        {({ formData, ...rest }) => formData.audienceSegmentOptions && (
          <SelectInput
            source="emailTemplateId"
            choices={formData.emailTemplates}
            optionText={choice => choice.name}
            validate={isRequired}
            {...rest}
          />
        )}
      </FormDataConsumer>
      <ReferenceInput
        label="Audiences"
        source="listId"
        reference="mailchimpAudiences"
      >
        <SelectInput
          optionText={choice => choice.name}
        />
      </ReferenceInput>
      <FormDataConsumer>
        {({ formData, ...rest }) => formData.listId && (
        <MySelect listId={formData.listId} {...rest} />
        )}
      </FormDataConsumer>
      <FormDataConsumer>
        {({ formData }) => formData && formData.segmentType === NEW_SEGMENT && formData.audienceSegmentOptions && (
          <AudienceSegmentSection audienceSegmentOptions={formData.audienceSegmentOptions} {...formData} />
        )}
      </FormDataConsumer>
      {/* <Accordion> */}
      {/* </Accordion> */}
    </SimpleForm>
  </Edit>
);




// WEBPACK FOOTER //
// ./src/components/OfferCampaign/Edit.js